// @ts-nocheck
import * as React from "react";

const GlobeFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 12.625C5.50816 12.625 4.07742 12.0324 3.02252 10.9775C1.96763 9.92258 1.375 8.49184 1.375 7C1.375 5.50816 1.96763 4.07742 3.02252 3.02252C4.07742 1.96763 5.50816 1.375 7 1.375M7 12.625C8.49184 12.625 9.92258 12.0324 10.9775 10.9775C12.0324 9.92258 12.625 8.49184 12.625 7C12.625 5.50816 12.0324 4.07742 10.9775 3.02252C9.92258 1.96763 8.49184 1.375 7 1.375M7 12.625C7 12.625 4.375 11.5 4.375 7C4.375 2.5 7 1.375 7 1.375M7 12.625C7 12.625 9.62497 11.5 9.62497 7C9.62497 2.5 7 1.375 7 1.375M1.69744 5.125H12.3024M1.69744 8.87501H12.3024"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(GlobeFill);
